import React, { useState } from 'react';
import './ImportarPedidos.css';
import { useOrders } from '../../contexts/OrdersContext';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar/sidebar';
import { Stack, Typography, Box, Container, Grid2 } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Buttons from '../../components/button';
import GenericImput from '../../components/text-imput';
import DragAndDropFileUpload from '../../components/upload/upload-file';
import DataTable from '../../components/data table/data-table';
import Modals from '../../components/modal/modal';
import CircularProgress from "@mui/material/CircularProgress";


const ImportarPedidos = () => {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const { samples, fetchOrderById, importFile, confirmImport } = useOrders();
    const [error, setError] = useState<string | null>(null);
    const [pedido, setPedido] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);

    const pedidosNavigation = () => {
        navigate('/pedidos');
    };

    const nextStep = async () => {
        if (!pedido) {
            setError("Informe o número do pedido.");
            return;
        }
        setError(null);
        setLoading(true);
        try {
            await fetchOrderById(pedido);
            setCurrentStep((prev) => prev + 1);
        } catch (error: any) {
            let errorMessage = "Ocorreu um erro inesperado.";
            if (error.response) {
                errorMessage = error.response.data?.message || "Erro ao buscar pedido.";
            } else if (error.message) {
                errorMessage = error.message;
            }
            setError(errorMessage);
        }
        setLoading(false);
    };

    const secondStep = async () => {
        if (!selectedFile) {
            setError("Selecione um arquivo antes de importar.");
            return;
        }
        setLoading(true);
        try {
            await importFile(selectedFile, pedido);
            setCurrentStep((prev) => prev + 1);
            setError(null);
        } catch (err: any) {
            setError(err.message || "Erro ao importar arquivo. Verifique os dados antes de importar.");
        }
        setLoading(false);
    };

    const thirdStep = async () => {
        setLoading(true);
        try {
            await confirmImport(pedido);
            handleOpenModal();
            setError(null);
        } catch (err: any) {
            setError(err.message || "Erro ao confirmar importação.");
        }
        setLoading(false);
    };

    const handleFileSelected = (file: File) => {
        setSelectedFile(file);
        console.log("Arquivo armazenado:", file);
    };


    const prevStep = () => {
        setCurrentStep((prev) => prev - 1);
    };

    const downloadModel = async () => {
        try {
            const response = await fetch("/files/planilha-modelo.xlsx");
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "planilha-modelo.xlsx";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Erro ao baixar o arquivo", error);
        }
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPedido(e.target.value);
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        pedidosNavigation();
    };

    return (
        <>
            <Header />
            {/* <Sidebar /> */}
            <Box className='import-form-content'>
                <Box className="page-link">
                    <Buttons label="Voltar"
                        onClick={pedidosNavigation}
                        backgroundColor="#FBFBFB"
                        textColor="var(--primary-color)"
                        starticon={<ArrowBackIcon />}
                        sx={{
                            boxShadow: 'none',
                            padding: '0.5rem 1rem',
                            marginBottom: '0.5rem',
                            '&:hover': {
                                backgroundColor: 'var(--secondary-color)',
                                boxShadow: 'none',
                            },
                        }} />
                </Box>
                <Container className="import-page-title">
                    <Stack direction="row" spacing={2}>
                        <Box className="import-title-icon">
                            <SvgIcon>
                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M23.2138 9.16125L17.0888 3.03625C16.9658 2.91314 16.799 2.8439 16.625 2.84375H6.125C5.71889 2.84375 5.32941 3.00508 5.04224 3.29224C4.75508 3.57941 4.59375 3.96889 4.59375 4.375V23.625C4.59375 24.0311 4.75508 24.4206 5.04224 24.7078C5.32941 24.9949 5.71889 25.1562 6.125 25.1562H21.875C22.2811 25.1562 22.6706 24.9949 22.9578 24.7078C23.2449 24.4206 23.4062 24.0311 23.4062 23.625V9.625C23.4061 9.45101 23.3369 9.2842 23.2138 9.16125ZM17.2812 5.08375L21.1663 8.96875H17.2812V5.08375ZM21.875 23.8438H6.125C6.06698 23.8438 6.01134 23.8207 5.97032 23.7797C5.9293 23.7387 5.90625 23.683 5.90625 23.625V4.375C5.90625 4.31698 5.9293 4.26134 5.97032 4.22032C6.01134 4.1793 6.06698 4.15625 6.125 4.15625H15.9688V9.625C15.9688 9.79905 16.0379 9.96597 16.161 10.089C16.284 10.2121 16.451 10.2812 16.625 10.2812H22.0938V23.625C22.0938 23.683 22.0707 23.7387 22.0297 23.7797C21.9887 23.8207 21.933 23.8438 21.875 23.8438ZM17.2812 16.625C17.2812 16.799 17.2121 16.966 17.089 17.089C16.966 17.2121 16.799 17.2812 16.625 17.2812H14.6562V19.25C14.6562 19.424 14.5871 19.591 14.464 19.714C14.341 19.8371 14.174 19.9062 14 19.9062C13.826 19.9062 13.659 19.8371 13.536 19.714C13.4129 19.591 13.3438 19.424 13.3438 19.25V17.2812H11.375C11.201 17.2812 11.034 17.2121 10.911 17.089C10.7879 16.966 10.7188 16.799 10.7188 16.625C10.7188 16.451 10.7879 16.284 10.911 16.161C11.034 16.0379 11.201 15.9688 11.375 15.9688H13.3438V14C13.3438 13.826 13.4129 13.659 13.536 13.536C13.659 13.4129 13.826 13.3438 14 13.3438C14.174 13.3438 14.341 13.4129 14.464 13.536C14.5871 13.659 14.6562 13.826 14.6562 14V15.9688H16.625C16.799 15.9688 16.966 16.0379 17.089 16.161C17.2121 16.284 17.2812 16.451 17.2812 16.625Z" fill="#2D7A89" />
                                </svg>
                            </SvgIcon>
                        </Box>
                        <Typography className="import-title-name"> Importar Pedidos</Typography>
                    </Stack>
                </Container>

                <Box className='import-form'>
                    {currentStep === 1 && (
                        <>
                            <Box className="step-container">
                                <Box className="step-item active">
                                    <SvgIcon className="step-icon">
                                        <svg
                                            width="32"
                                            height="32"
                                            viewBox="0 0 32 32"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#2D7A89" />
                                            <path
                                                d="M13.3388 21V19.6H15.6488V13.552H13.3248V12.502C13.6048 12.474 13.9315 12.4087 14.3048 12.306C14.6875 12.194 15.0748 12.0587 15.4668 11.9C15.8588 11.7413 16.2135 11.5733 16.5308 11.396H17.3708V19.6H19.4988V21H13.3388Z"
                                                fill="#2D7A89"
                                            />
                                        </svg>
                                    </SvgIcon>
                                    <Typography className="step-label">Identificação do pedido</Typography>
                                </Box>

                                <Box className="step-connector" />

                                <Box className="step-item">
                                    <SvgIcon className="step-icon">
                                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="0.5" width="31" height="31" rx="15.5" stroke="#CDD2D9" />
                                            <path d="M13.1808 21V20.538C13.1808 20.118 13.2555 19.7353 13.4048 19.39C13.5541 19.0447 13.7548 18.732 14.0068 18.452C14.2588 18.1627 14.5388 17.892 14.8468 17.64C15.1641 17.3787 15.4815 17.1313 15.7988 16.898C16.1908 16.6087 16.5595 16.3193 16.9048 16.03C17.2501 15.7313 17.5301 15.414 17.7448 15.078C17.9595 14.7327 18.0668 14.35 18.0668 13.93C18.0668 13.734 18.0201 13.538 17.9268 13.342C17.8335 13.146 17.6795 12.9827 17.4648 12.852C17.2595 12.7213 16.9795 12.656 16.6248 12.656C16.2701 12.656 15.9761 12.7167 15.7428 12.838C15.5095 12.95 15.3321 13.1133 15.2108 13.328C15.0988 13.5427 15.0428 13.8087 15.0428 14.126V14.7H13.3348C13.3255 14.6533 13.3161 14.5833 13.3068 14.49C13.2975 14.3967 13.2928 14.28 13.2928 14.14C13.2928 13.4493 13.4468 12.894 13.7548 12.474C14.0721 12.0447 14.4875 11.732 15.0008 11.536C15.5235 11.3307 16.0881 11.228 16.6948 11.228C17.3295 11.228 17.8475 11.3213 18.2488 11.508C18.6595 11.6947 18.9768 11.9327 19.2008 12.222C19.4341 12.5113 19.5928 12.8193 19.6768 13.146C19.7701 13.4727 19.8168 13.7713 19.8168 14.042C19.8168 14.49 19.7375 14.9007 19.5788 15.274C19.4295 15.638 19.2195 15.9833 18.9488 16.31C18.6781 16.6273 18.3561 16.9353 17.9828 17.234C17.6188 17.5233 17.2268 17.8173 16.8068 18.116C16.5921 18.2653 16.3821 18.4147 16.1768 18.564C15.9715 18.7133 15.7895 18.8627 15.6308 19.012C15.4815 19.1613 15.3648 19.3107 15.2808 19.46H19.8728V21H13.1808Z" fill="#CDD2D9" />
                                        </svg>
                                    </SvgIcon>
                                    <Typography className="step-label">Importação</Typography>
                                </Box>

                                <Box className="step-connector" />

                                <Box className="step-item">
                                    <SvgIcon className="step-icon">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#CDD2D9" />
                                            <path d="M16.0268 21.168C15.2895 21.168 14.6641 21.0513 14.1508 20.818C13.6375 20.5753 13.2455 20.2393 12.9748 19.81C12.7135 19.3713 12.5828 18.8627 12.5828 18.284V18.074H14.3188V18.326C14.3188 18.7927 14.4635 19.152 14.7528 19.404C15.0421 19.6467 15.4481 19.768 15.9708 19.768C16.4655 19.768 16.8621 19.6513 17.1608 19.418C17.4595 19.1847 17.6088 18.8113 17.6088 18.298C17.6088 17.8967 17.5248 17.5933 17.3568 17.388C17.1981 17.1733 16.9835 17.024 16.7128 16.94C16.4515 16.856 16.1668 16.814 15.8588 16.814H15.0608V15.414H15.9008C16.1808 15.414 16.4328 15.3627 16.6568 15.26C16.8901 15.1573 17.0721 14.9987 17.2028 14.784C17.3428 14.5693 17.4128 14.2987 17.4128 13.972C17.4128 13.6547 17.3521 13.398 17.2308 13.202C17.1095 13.006 16.9415 12.8613 16.7268 12.768C16.5121 12.6747 16.2695 12.628 15.9988 12.628C15.7095 12.628 15.4528 12.6793 15.2288 12.782C15.0048 12.8753 14.8321 13.0247 14.7108 13.23C14.5895 13.426 14.5288 13.678 14.5288 13.986V14.21H12.7928V13.86C12.7928 13.328 12.9281 12.866 13.1988 12.474C13.4695 12.0727 13.8428 11.7647 14.3188 11.55C14.8041 11.3353 15.3548 11.228 15.9708 11.228C16.6055 11.228 17.1608 11.3307 17.6368 11.536C18.1221 11.732 18.5001 12.026 18.7708 12.418C19.0415 12.81 19.1768 13.2907 19.1768 13.86C19.1768 14.2333 19.1068 14.56 18.9668 14.84C18.8361 15.1107 18.6541 15.3393 18.4208 15.526C18.1875 15.7127 17.9261 15.876 17.6368 16.016V16.072C18.1315 16.2213 18.5421 16.492 18.8688 16.884C19.2048 17.276 19.3728 17.7893 19.3728 18.424C19.3728 18.9933 19.2281 19.4833 18.9388 19.894C18.6588 20.3047 18.2668 20.622 17.7628 20.846C17.2588 21.0607 16.6801 21.168 16.0268 21.168Z" fill="#CDD2D9" />
                                        </svg>
                                    </SvgIcon>
                                    <Typography className="step-label">Confirmação</Typography>
                                </Box>
                            </Box>

                            <Box sx={{ margin: '20px' }}>
                                <Typography>Informe o número do pedido</Typography>
                            </Box>
                            <Box sx={{ margin: '20px' }}>
                                <GenericImput label="Pedido" placeholder="Nº do Pedido" type="text"
                                    value={pedido}
                                    onChange={(e) => setPedido(e.target.value)} />
                            </Box>
                            {error && <Typography className='error-message'>{error}</Typography>}
                            <Box sx={{ margin: '20px', display: 'flex', justifyContent: 'center', justifyItems: 'center' }}>
                                <Buttons
                                    label="Avançar"
                                    onClick={nextStep}
                                    backgroundColor="var(--primary-color)"
                                    isLoading={loading}
                                    disabled={loading}
                                    textColor="#fff"
                                    fullWidth={false}
                                    sx={{
                                        boxShadow: 'none',
                                        padding: '0.5rem 1rem',
                                        marginBottom: '0.5rem'
                                    }}
                                />
                            </Box>
                        </>
                    )}


                    {currentStep === 2 && (
                        <>
                            <Box className="step-container">
                                <Box className="step-item ">
                                    <SvgIcon className="step-icon">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#4AB446" />
                                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#4AB446" />
                                            <path d="M22.3538 12.8538L14.3538 20.8538C14.3073 20.9003 14.2522 20.9372 14.1915 20.9623C14.1308 20.9875 14.0657 21.0004 14 21.0004C13.9343 21.0004 13.8693 20.9875 13.8086 20.9623C13.7479 20.9372 13.6927 20.9003 13.6463 20.8538L10.1463 17.3538C10.0525 17.26 9.99976 17.1327 9.99976 17C9.99976 16.8674 10.0525 16.7401 10.1463 16.6463C10.2401 16.5525 10.3674 16.4998 10.5 16.4998C10.6327 16.4998 10.76 16.5525 10.8538 16.6463L14 19.7932L21.6463 12.1463C21.7401 12.0525 21.8674 11.9998 22 11.9998C22.1327 11.9998 22.26 12.0525 22.3538 12.1463C22.4476 12.2401 22.5003 12.3674 22.5003 12.5C22.5003 12.6327 22.4476 12.76 22.3538 12.8538Z" fill="white" />
                                        </svg>
                                    </SvgIcon>
                                    <Typography className="step-label">Identificação do pedido</Typography>
                                </Box>

                                <Box className="step-connector" />

                                <Box className="step-item active">
                                    <SvgIcon className="step-icon">
                                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="1" y="0.5" width="31" height="31" rx="15.5" stroke="#2D7A89" />
                                            <path d="M13.1808 21V20.538C13.1808 20.118 13.2555 19.7353 13.4048 19.39C13.5541 19.0447 13.7548 18.732 14.0068 18.452C14.2588 18.1627 14.5388 17.892 14.8468 17.64C15.1641 17.3787 15.4815 17.1313 15.7988 16.898C16.1908 16.6087 16.5595 16.3193 16.9048 16.03C17.2501 15.7313 17.5301 15.414 17.7448 15.078C17.9595 14.7327 18.0668 14.35 18.0668 13.93C18.0668 13.734 18.0201 13.538 17.9268 13.342C17.8335 13.146 17.6795 12.9827 17.4648 12.852C17.2595 12.7213 16.9795 12.656 16.6248 12.656C16.2701 12.656 15.9761 12.7167 15.7428 12.838C15.5095 12.95 15.3321 13.1133 15.2108 13.328C15.0988 13.5427 15.0428 13.8087 15.0428 14.126V14.7H13.3348C13.3255 14.6533 13.3161 14.5833 13.3068 14.49C13.2975 14.3967 13.2928 14.28 13.2928 14.14C13.2928 13.4493 13.4468 12.894 13.7548 12.474C14.0721 12.0447 14.4875 11.732 15.0008 11.536C15.5235 11.3307 16.0881 11.228 16.6948 11.228C17.3295 11.228 17.8475 11.3213 18.2488 11.508C18.6595 11.6947 18.9768 11.9327 19.2008 12.222C19.4341 12.5113 19.5928 12.8193 19.6768 13.146C19.7701 13.4727 19.8168 13.7713 19.8168 14.042C19.8168 14.49 19.7375 14.9007 19.5788 15.274C19.4295 15.638 19.2195 15.9833 18.9488 16.31C18.6781 16.6273 18.3561 16.9353 17.9828 17.234C17.6188 17.5233 17.2268 17.8173 16.8068 18.116C16.5921 18.2653 16.3821 18.4147 16.1768 18.564C15.9715 18.7133 15.7895 18.8627 15.6308 19.012C15.4815 19.1613 15.3648 19.3107 15.2808 19.46H19.8728V21H13.1808Z" fill="#2D7A89" />
                                        </svg>
                                    </SvgIcon>
                                    <Typography className="step-label">Importação</Typography>
                                </Box>

                                <Box className="step-connector" />

                                <Box className="step-item">
                                    <SvgIcon className="step-icon">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#CDD2D9" />
                                            <path d="M16.0268 21.168C15.2895 21.168 14.6641 21.0513 14.1508 20.818C13.6375 20.5753 13.2455 20.2393 12.9748 19.81C12.7135 19.3713 12.5828 18.8627 12.5828 18.284V18.074H14.3188V18.326C14.3188 18.7927 14.4635 19.152 14.7528 19.404C15.0421 19.6467 15.4481 19.768 15.9708 19.768C16.4655 19.768 16.8621 19.6513 17.1608 19.418C17.4595 19.1847 17.6088 18.8113 17.6088 18.298C17.6088 17.8967 17.5248 17.5933 17.3568 17.388C17.1981 17.1733 16.9835 17.024 16.7128 16.94C16.4515 16.856 16.1668 16.814 15.8588 16.814H15.0608V15.414H15.9008C16.1808 15.414 16.4328 15.3627 16.6568 15.26C16.8901 15.1573 17.0721 14.9987 17.2028 14.784C17.3428 14.5693 17.4128 14.2987 17.4128 13.972C17.4128 13.6547 17.3521 13.398 17.2308 13.202C17.1095 13.006 16.9415 12.8613 16.7268 12.768C16.5121 12.6747 16.2695 12.628 15.9988 12.628C15.7095 12.628 15.4528 12.6793 15.2288 12.782C15.0048 12.8753 14.8321 13.0247 14.7108 13.23C14.5895 13.426 14.5288 13.678 14.5288 13.986V14.21H12.7928V13.86C12.7928 13.328 12.9281 12.866 13.1988 12.474C13.4695 12.0727 13.8428 11.7647 14.3188 11.55C14.8041 11.3353 15.3548 11.228 15.9708 11.228C16.6055 11.228 17.1608 11.3307 17.6368 11.536C18.1221 11.732 18.5001 12.026 18.7708 12.418C19.0415 12.81 19.1768 13.2907 19.1768 13.86C19.1768 14.2333 19.1068 14.56 18.9668 14.84C18.8361 15.1107 18.6541 15.3393 18.4208 15.526C18.1875 15.7127 17.9261 15.876 17.6368 16.016V16.072C18.1315 16.2213 18.5421 16.492 18.8688 16.884C19.2048 17.276 19.3728 17.7893 19.3728 18.424C19.3728 18.9933 19.2281 19.4833 18.9388 19.894C18.6588 20.3047 18.2668 20.622 17.7628 20.846C17.2588 21.0607 16.6801 21.168 16.0268 21.168Z" fill="#CDD2D9" />
                                        </svg>
                                    </SvgIcon>
                                    <Typography className="step-label">Confirmação</Typography>
                                </Box>
                            </Box>
                            <Box sx={{
                                margin: '20px', display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                                <DragAndDropFileUpload order={pedido} onFileSelected={handleFileSelected} />
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                                <Typography>Extensão: .xlsx, .xls, .csv. O modelo de importação pode ser baixado </Typography>
                                <Buttons
                                    label="clicando aqui."
                                    onClick={downloadModel}
                                    backgroundColor="#fff"
                                    textColor="var(--primary-color)"
                                    borderColor='var(--primary-color)'
                                    fullWidth={false}
                                    size='small'
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: '12px',
                                        boxShadow: 'none',
                                        padding: '0.5rem 1rem'
                                    }}
                                />
                            </Box>
                            {error && <Typography className='error-message' sx={{ mt: 2 }}>{error}</Typography>}
                            <Box sx={{ margin: '20px', display: 'flex', justifyContent: 'center', justifyItems: 'center', gap: 3 }}>
                                <Buttons label="Voltar"
                                    onClick={prevStep}
                                    backgroundColor="#FBFBFB"
                                    textColor="var(--primary-color)"
                                    isLoading={loading}
                                    disabled={loading}
                                    starticon={<ArrowBackIcon />}
                                    fullWidth={false}
                                    sx={{
                                        boxShadow: 'none',
                                        padding: '0.5rem 1rem',
                                        marginBottom: '0.5rem',
                                        '&:hover': {
                                            backgroundColor: 'var(--secondary-color)',
                                            boxShadow: 'none',
                                        },
                                    }} />
                                <Buttons
                                    label="Importar"
                                    onClick={secondStep}
                                    backgroundColor="var(--primary-color)"
                                    textColor="#fff"
                                    fullWidth={false}
                                    sx={{
                                        boxShadow: 'none',
                                        padding: '0.5rem 1rem',
                                        marginBottom: '0.5rem'
                                    }}
                                />
                            </Box>
                        </>
                    )}

                    {currentStep === 3 && (
                        <>
                            <Box className="step-container">
                                <Box className="step-item ">
                                    <SvgIcon className="step-icon">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#4AB446" />
                                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#4AB446" />
                                            <path d="M22.3538 12.8538L14.3538 20.8538C14.3073 20.9003 14.2522 20.9372 14.1915 20.9623C14.1308 20.9875 14.0657 21.0004 14 21.0004C13.9343 21.0004 13.8693 20.9875 13.8086 20.9623C13.7479 20.9372 13.6927 20.9003 13.6463 20.8538L10.1463 17.3538C10.0525 17.26 9.99976 17.1327 9.99976 17C9.99976 16.8674 10.0525 16.7401 10.1463 16.6463C10.2401 16.5525 10.3674 16.4998 10.5 16.4998C10.6327 16.4998 10.76 16.5525 10.8538 16.6463L14 19.7932L21.6463 12.1463C21.7401 12.0525 21.8674 11.9998 22 11.9998C22.1327 11.9998 22.26 12.0525 22.3538 12.1463C22.4476 12.2401 22.5003 12.3674 22.5003 12.5C22.5003 12.6327 22.4476 12.76 22.3538 12.8538Z" fill="white" />
                                        </svg>
                                    </SvgIcon>
                                    <Typography className="step-label">Identificação do pedido</Typography>
                                </Box>

                                <Box className="step-connector" />

                                <Box className="step-item">
                                    <SvgIcon className="step-icon">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="#4AB446" />
                                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#4AB446" />
                                            <path d="M22.3538 12.8538L14.3538 20.8538C14.3073 20.9003 14.2522 20.9372 14.1915 20.9623C14.1308 20.9875 14.0657 21.0004 14 21.0004C13.9343 21.0004 13.8693 20.9875 13.8086 20.9623C13.7479 20.9372 13.6927 20.9003 13.6463 20.8538L10.1463 17.3538C10.0525 17.26 9.99976 17.1327 9.99976 17C9.99976 16.8674 10.0525 16.7401 10.1463 16.6463C10.2401 16.5525 10.3674 16.4998 10.5 16.4998C10.6327 16.4998 10.76 16.5525 10.8538 16.6463L14 19.7932L21.6463 12.1463C21.7401 12.0525 21.8674 11.9998 22 11.9998C22.1327 11.9998 22.26 12.0525 22.3538 12.1463C22.4476 12.2401 22.5003 12.3674 22.5003 12.5C22.5003 12.6327 22.4476 12.76 22.3538 12.8538Z" fill="white" />
                                        </svg>
                                    </SvgIcon>
                                    <Typography className="step-label">Importação</Typography>
                                </Box>

                                <Box className="step-connector" />

                                <Box className="step-item active">
                                    <SvgIcon className="step-icon">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#2D7A89" />
                                            <path d="M16.0268 21.168C15.2895 21.168 14.6641 21.0513 14.1508 20.818C13.6375 20.5753 13.2455 20.2393 12.9748 19.81C12.7135 19.3713 12.5828 18.8627 12.5828 18.284V18.074H14.3188V18.326C14.3188 18.7927 14.4635 19.152 14.7528 19.404C15.0421 19.6467 15.4481 19.768 15.9708 19.768C16.4655 19.768 16.8621 19.6513 17.1608 19.418C17.4595 19.1847 17.6088 18.8113 17.6088 18.298C17.6088 17.8967 17.5248 17.5933 17.3568 17.388C17.1981 17.1733 16.9835 17.024 16.7128 16.94C16.4515 16.856 16.1668 16.814 15.8588 16.814H15.0608V15.414H15.9008C16.1808 15.414 16.4328 15.3627 16.6568 15.26C16.8901 15.1573 17.0721 14.9987 17.2028 14.784C17.3428 14.5693 17.4128 14.2987 17.4128 13.972C17.4128 13.6547 17.3521 13.398 17.2308 13.202C17.1095 13.006 16.9415 12.8613 16.7268 12.768C16.5121 12.6747 16.2695 12.628 15.9988 12.628C15.7095 12.628 15.4528 12.6793 15.2288 12.782C15.0048 12.8753 14.8321 13.0247 14.7108 13.23C14.5895 13.426 14.5288 13.678 14.5288 13.986V14.21H12.7928V13.86C12.7928 13.328 12.9281 12.866 13.1988 12.474C13.4695 12.0727 13.8428 11.7647 14.3188 11.55C14.8041 11.3353 15.3548 11.228 15.9708 11.228C16.6055 11.228 17.1608 11.3307 17.6368 11.536C18.1221 11.732 18.5001 12.026 18.7708 12.418C19.0415 12.81 19.1768 13.2907 19.1768 13.86C19.1768 14.2333 19.1068 14.56 18.9668 14.84C18.8361 15.1107 18.6541 15.3393 18.4208 15.526C18.1875 15.7127 17.9261 15.876 17.6368 16.016V16.072C18.1315 16.2213 18.5421 16.492 18.8688 16.884C19.2048 17.276 19.3728 17.7893 19.3728 18.424C19.3728 18.9933 19.2281 19.4833 18.9388 19.894C18.6588 20.3047 18.2668 20.622 17.7628 20.846C17.2588 21.0607 16.6801 21.168 16.0268 21.168Z" fill="#2D7A89" />
                                        </svg>
                                    </SvgIcon>
                                    <Typography className="step-label">Confirmação</Typography>
                                </Box>
                            </Box>
                            <Box sx={{
                                margin: '20px', display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                                <DataTable data={samples} />
                            </Box>
                            {error && <Typography className='error-message' sx={{ mt: 2 }}>{error}</Typography>}
                            <Box sx={{ margin: '20px', display: 'flex', justifyContent: 'center', justifyItems: 'center', gap: 3 }}>
                                <Buttons label="Voltar"
                                    onClick={prevStep}
                                    backgroundColor="#FBFBFB"
                                    textColor="var(--primary-color)"
                                    starticon={<ArrowBackIcon />}
                                    fullWidth={false}
                                    sx={{
                                        boxShadow: 'none',
                                        padding: '0.5rem 1rem',
                                        marginBottom: '0.5rem',
                                        '&:hover': {
                                            backgroundColor: 'var(--secondary-color)',
                                            boxShadow: 'none',
                                        },
                                    }} />
                                <Buttons
                                    label="Confirmar Pedido"
                                    onClick={thirdStep}
                                    backgroundColor="var(--primary-color)"
                                    disabled={loading}
                                    isLoading={loading}
                                    textColor="#fff"
                                    fullWidth={false}
                                    sx={{
                                        boxShadow: 'none',
                                        padding: '0.5rem 1rem',
                                        marginBottom: '0.5rem'
                                    }}
                                />
                                <Modals open={isModalOpen}
                                    title="Pedido realizado com sucesso"
                                    type='success'
                                    starticon={<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clipPath="url(#clip0_437_5154)">
                                            <path d="M22 34L28 40L42 26" stroke="#FF9D33" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56Z" stroke="#FF9D33" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_437_5154">
                                                <rect width="64" height="64" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    }
                                    actions={
                                        <>
                                            <Buttons
                                                label="Fechar"
                                                onClick={handleCloseModal}
                                                backgroundColor="var(--primary-color)"
                                                textColor="#fff"
                                                fullWidth={false}
                                                sx={{
                                                    boxShadow: 'none',
                                                    padding: '0.5rem 1rem',
                                                    marginBottom: '0.5rem'
                                                }}
                                            />
                                        </>
                                    }
                                    onClose={handleCloseModal} />
                            </Box>
                        </>
                    )}
                </Box>

            </Box>
        </>

    );
}

export default ImportarPedidos;